export const defaultOperationModes: string[] = ['Unmanned', 'Closed', 'Out_Of_Service'];

export const formatTime = (time: string): string => {
    if (!time) return '00:00';
    if (/^\d{2}:\d{2}/.test(time)) return time.substring(0, 5);
    const parts = time.split(':');
    return `${parts[0]?.padStart(2, '0') || '00'}:${parts[1]?.padStart(2, '0') || '00'}`;
};

export const formatDate = (date?: string): string => {
    if (!date) return 'N/A';
    const d = new Date(date);
    if (isNaN(d.getTime())) return 'N/A';

    return d.toLocaleDateString('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};
